import { defineMessages } from 'react-intl';

export const footerTranslations = defineMessages({
    w3dLink: {
        id: 'Footer.w3d.Link',
        defaultMessage: 'https://welovedevs.com'
    },
    w3dSentence: {
        id: 'Footer.w3d.Sentence',
        defaultMessage: 'We find dream jobs for developers.'
    },
    developerCategory: {
        id: 'Footer.Category.Developer',
        defaultMessage: 'Developer'
    },
    recruiterCategory: {
        id: 'Footer.Category.Recruiter',
        defaultMessage: 'Recruiter'
    },
    moreCategory: {
        id: 'Footer.Category.More',
        defaultMessage: 'Go further'
    },
    createProfile: {
        id: 'Footer.Category.Developer.CreateProfile',
        defaultMessage: 'Create my developer profile'
    },
    createProfileLink: {
        id: 'Footer.Category.Developer.CreateProfile.Link',
        defaultMessage: 'https://welovedevs.com/app/register_developer'
    },
    seeJobOffers: {
        id: 'Footer.Category.Developer.SeeJobOffers',
        defaultMessage: 'See developers job offers'
    },
    seeJobOffersLink: {
        id: 'Footer.Category.Developer.SeeJobOffers.Link',
        defaultMessage: 'https://welovedevs.com/app/jobs'
    },
    technicalTests: {
        id: 'Footer.Category.Developer.TechnicalTests',
        defaultMessage: 'Technical tests and quiz'
    },
    technicalTestsLink: {
        id: 'Footer.Category.Developer.TechnicalTests.Link',
        defaultMessage: 'https://welovedevs.com/app/tests'
    },
    joinCommunity: {
        id: 'Footer.Category.Developer.JoinCommunity',
        defaultMessage: 'Join our developer community'
    },
    joinCommunityLink: {
        id: 'Footer.Category.Developer.JoinCommunity.Link',
        defaultMessage: 'https://discord.com/invite/Ep6A9Ew6uU'
    },
    training: {
        id: 'Footer.Category.Developer.Training',
        defaultMessage: 'Training and coaching for developers'
    },
    trainingLink: {
        id: 'Footer.Category.Developer.Training.Link',
        defaultMessage: 'https://school.welovedevs.com/'
    },
    hireDeveloper: {
        id: 'Footer.Category.Recruiter.HireDeveloper',
        defaultMessage: 'Meet and hire developers'
    },
    hireDeveloperLink: {
        id: 'Footer.Category.Recruiter.HireDeveloper.Link',
        defaultMessage: 'https://welovedevs.com/app/register_recruiter'
    },
    createCompanyPage: {
        id: 'Footer.Category.Recruiter.createCompanyPage',
        defaultMessage: 'Create my company page'
    },
    createCompanyPageLink: {
        id: 'Footer.Category.Recruiter.createCompanyPage.Link',
        defaultMessage: 'https://welovedevs.com/app/register_recruiter'
    },
    postJobOffers: {
        id: 'Footer.Category.Recruiter.postJobOffers',
        defaultMessage: 'Post job offers'
    },
    postJobOffersLink: {
        id: 'Footer.Category.Recruiter.postJobOffers.Link',
        defaultMessage: 'https://welovedevs.com/app/register_recruiter'
    },
    testMyCandidates: {
        id: 'Footer.Category.Recruiter.testMyCandidates',
        defaultMessage: 'Test my developers'
    },
    testMyCandidatesLink: {
        id: 'Footer.Category.Recruiter.testMyCandidates.Link',
        defaultMessage: 'https://welovedevs.com/fr/tests-techniques/'
    },
    recruiterTraining: {
        id: 'Footer.Category.Recruiter.recruiterTraining',
        defaultMessage: 'Training and coaching for recruiters'
    },
    recruiterTrainingLink: {
        id: 'Footer.Category.Recruiter.recruiterTraining.Link',
        defaultMessage: 'https://welovedevs.com/fr/recruteurs/formations/'
    },
    blog: {
        id: 'Footer.Category.More.recruiterTraining',
        defaultMessage: 'Blog'
    },
    blogLink: {
        id: 'Footer.Category.More.recruiterTraining.Link',
        defaultMessage: 'https://welovedevs.com/blog/'
    },
    salaries: {
        id: 'Footer.Category.More.salaries',
        defaultMessage: 'Developer salaries report'
    },
    salariesLink: {
        id: 'Footer.Category.More.salaries.Link',
        defaultMessage: 'https://welovedevs.com/fr/salaires/'
    },
    openSource: {
        id: 'Footer.Category.More.openSource',
        defaultMessage: 'Open Source'
    },
    openSourceLink: {
        id: 'Footer.Category.More.openSource.Link',
        defaultMessage: 'https://github.com/welovedevs/react-ultimate-resume'
    },
    privacy: {
        id: 'Footer.Category.More.privacy',
        defaultMessage: 'Privacy'
    },
    privacyLink: {
        id: 'Footer.Category.More.privacy.Link',
        defaultMessage: 'https://welovedevs.com/fr/data-policy.html'
    },
});
